// extracted by mini-css-extract-plugin
module.exports = {"loader-abs":"CircularProgress_loader-abs__GUrwv","loader":"CircularProgress_loader__3EEwS","spin":"CircularProgress_spin__2K6a9"};